import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/site";

export const Reveal = ({ children, delay = 0, className = "", as = "div" }) => {
  const Tag = motion[as] || motion.div;
  return (
    <Tag
      className={className}
      initial={{ opacity: 0, y: 28 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-70px" }}
      transition={{ duration: 0.9, delay, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </Tag>
  );
};

export const Eyebrow = ({ children, dark = false }) => (
  <p
    className={`text-xs md:text-sm font-sans font-semibold uppercase tracking-[0.28em] ${
      dark ? "text-[#D4AF37]" : "text-[#A98A2C]"
    }`}
  >
    {children}
  </p>
);

export const GoldLine = ({ className = "" }) => (
  <motion.div
    aria-hidden="true"
    initial={{ scaleX: 0 }}
    whileInView={{ scaleX: 1 }}
    viewport={{ once: true }}
    transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
    className={`h-px w-24 origin-left bg-[#D4AF37] ${className}`}
  />
);

export const WhatsAppButton = ({
  label = "Parla con Chiara",
  testid,
  variant = "solid",
  className = "",
}) => {
  const base =
    "group inline-flex items-center justify-center gap-3 px-8 py-4 text-sm font-sans font-semibold uppercase tracking-[0.15em] transition-colors duration-300 rounded-sm";
  const styles =
    variant === "solid"
      ? "bg-[#1A1818] text-[#FDFBF7] hover:bg-[#2A2421]"
      : variant === "gold"
        ? "bg-[#D4AF37] text-[#1A1818] hover:bg-[#C39E2B]"
        : "border border-[#1A1818]/30 text-[#1A1818] hover:border-[#D4AF37] hover:text-[#A98A2C]";
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noopener noreferrer"
      data-testid={testid}
      className={`${base} ${styles} ${className}`}
    >
      <span>{label}</span>
      <ArrowUpRight
        className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
        strokeWidth={1.75}
      />
    </a>
  );
};
